import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { Button, Col, Icon, Row } from '../Component';
import TextInput from '../../pages/components/inputs/TextInput';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { UPDATE_TENANT_PRODUCT_PRICE_API } from '../../api/api_data';
import * as app_consts from "../../utils/app_consts";
import { fail_update_tenant_product_price, loading_update_tenant_product_price, reset_update_tenant_product_price, success_update_tenant_product_price } from '../../reducers/auth_tenant/update_tenant_product_price_Slice';
import { UPDATE_TENANT_PRODUCT_PRICE_ERROR_MSG, UPDATE_TENANT_PRODUCT_PRICE_SUCCESS_MSG } from '../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { messageToast } from '../../utils/Utils';

const initialState = { product_id: "", new_value: "", reason: "", effective_date: "" };

const UpdateProductPriceModal = ({ isOpen, closeModal, data, tenant_info, user_info, successFunction }) => {

 const [page_data, setPageData] = useState(data);
 const [open, setOpen] = useState(isOpen);
 const [loading, setLoading] = useState(false);
 const [error, setError] = useState("");
 const dispatch = useDispatch();
 const [formData, setFormData] = useState(initialState);

 // Handle Change Function
 const handleChange = (e) => {
  setFormData({ ...formData, [e.target.name]: e.target.value });
 };

 useEffect(() => {
  setPageData(data);
  setOpen(isOpen);
  setFormData({ ...formData, product_id: data?.id, new_value: "", reason: "" });
 }, [data, isOpen]);

 const handle_update_product_price = () => {
  setError("");
  const offsetMinutes = new Date().getTimezoneOffset();
  const offsetHours = Math.abs(offsetMinutes) / 60;
  const offsetSign = offsetMinutes > 0 ? "-" : "+";
  const formattedOffset = `${offsetSign}${String(offsetHours).padStart(2, "0")}:00`;

  const req_data = { ...formData, effective_date: `${formData?.effective_date}${formattedOffset}` };
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_update_tenant_product_price, success_update_tenant_product_price, fail_update_tenant_product_price, UPDATE_TENANT_PRODUCT_PRICE_ERROR_MSG, UPDATE_TENANT_PRODUCT_PRICE_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${UPDATE_TENANT_PRODUCT_PRICE_API}`, req_data));
 };

 // Listener
 const update_tenant_product_price_listener = useSelector((state) => state.update_tenant_product_price.update_tenant_product_price);

 useEffect(() => {
  if (update_tenant_product_price_listener.status !== app_consts.IDLE)
  {
   if (update_tenant_product_price_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    if (update_tenant_product_price_listener.status === app_consts.FAIL)
    {
     setLoading(false);
     setError(update_tenant_product_price_listener.message);
     messageToast(update_tenant_product_price_listener.message, app_consts.FAIL);
    } else if (update_tenant_product_price_listener.status === app_consts.SUCCESS)
    {
     messageToast(UPDATE_TENANT_PRODUCT_PRICE_SUCCESS_MSG, app_consts.SUCCESS);
     successFunction();
    }
    dispatch(reset_update_tenant_product_price());
   }
  }
 }, [update_tenant_product_price_listener]);

 return (
  <>
   < Modal isOpen={open} className="modal-dialog-centered" size={"md"} >
    <ModalHeader toggle={loading ? "" : closeModal}>Update Product Price</ModalHeader>
    <ModalBody>
     <Row className="g-4">
      <TextInput
       label="New Value (Per Unit in ZMW)"
       type="number"
       id_val="new_value"
       value={formData?.new_value}
       colSize="12"
       required
       name="new_value"
       handleChange={handleChange}
      />
      <TextInput
       label="Update Reason"
       type="text"
       id_val="reason"
       value={formData?.reason}
       colSize="12"
       name="reason"
       required
       handleChange={handleChange}
      />
      <Col lg={12}>
       <div className="form-group">
        <label className="form-label mb-1 text-md" htmlFor="retrunable">
         Effective Date<span className='text-danger pr-2'>{` *`}</span>
        </label>
        <div className="w-100">

         <input
          type="datetime-local"
          name="effective_date"
          value={formData?.effective_date}
          className="form-control"
          onChange={(e) => setFormData({ ...formData, effective_date: e.target.value })}
         />
        </div>
       </div>
      </Col>
     </Row>
     {error && (
      <div className="my-3 w-100">
       <Alert color="danger" className="alert-icon">
        <Icon name="alert-circle" /> {error}{" "}
       </Alert>
      </div>
     )}
     <Col xl="12" className="d-flex justify-content-end mt-4 mr-2">
      <Button onClick={handle_update_product_price} disabled={
       (loading) ||
       !(formData?.new_value && formData?.product_id && formData?.reason && formData?.effective_date)
      } color="primary">
       {loading ? <Spinner size="sm" color="light" /> : "Update Product Price"}
      </Button>
     </Col>
    </ModalBody>
   </Modal>
  </>
 );
};

export default UpdateProductPriceModal;